import React, { useState } from 'react'
import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import {
  Close as CloseIcon,
} from "@mui/icons-material";
import { button_bg_color_for_New_Project } from '../../../../constants/colors';

const VideoCreationDialogForVeo = ({ open, onClose, videoTitle, dailogMessage}) => {
    const [loading, setLoading] = useState(true);
    const [errorMsg, setErrorMsg] = useState("");
    const [progress, setProgress] = useState(0);
    const [status, setStatus] = useState("pending");
    const [statusMessage, setStatusMessage] = useState(
        "Video generation Started..."
      );
    const theme = localStorage.getItem('theme');
  return (
     <Dialog
      open={open}
      onClose={
        status === "completed" || status === "failed" ? onClose : undefined
      }
      maxWidth="sm"
      fullWidth
       PaperProps={{
          sx: {
            bgcolor: "#1F233E",
            color: "white",
            borderRadius: "16px",
            margin:"0px"
          },
        }}
    >
      <DialogTitle sx={{
            color: "white",
            fontSize: "18px",
            fontWeight: 600,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding:"16px 20px",
            borderBottom:"1px solid rgba(255, 255, 255, 0.10)",
            maxHeight:"60px"
          }}>
        {videoTitle}
          <IconButton
            onClick={onClose}
            sx={{ color: "#ccc" }}
          >
            <CloseIcon />
          </IconButton>
      </DialogTitle>
      <DialogContent dividers  sx={{display:"flex", justifyContent:"center", margin:"20px 25px", padding:"0px"}}>
        <Box sx={{ minHeight: 50 }}>
          {/* Processing State */}
            <Box>
              <Box display="flex" alignItems="center" gap={2} mb={2}>
                <CircularProgress size={24} />
                <Typography variant="body1" color="rgba(255, 255, 255, 0.80)">{dailogMessage}</Typography>
              </Box>

              {/* Progress Bar */}
              {/* <Box sx={{ width: "100%", mb: 2 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Box sx={{ width: "100%" }}>
                    <Box
                      sx={{
                        height: 8,
                        borderRadius: 4,
                        bgcolor: "rgba(0, 161, 255, 0.1)",
                        overflow: "hidden",
                        position: "relative",
                      }}
                    >
                      <Box
                        sx={{
                          height: "100%",
                          width: `${progress}%`,
                          bgcolor: "#00a1ff",
                          borderRadius: 4,
                          transition: "width 0.5s ease-in-out",
                        }}
                      />
                    </Box>
                  </Box>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ minWidth: 45 }}
                  >
                    {progress}%
                  </Typography>
                </Box>
              </Box> */}

              {/* <Typography variant="caption" color="rgba(255, 255, 255, 0.80)">
                This may take 2-5 minutes depending on video length
              </Typography> */}
            </Box>
      

          {/* Initial Loading State */}
          {/* {status === "pending" && loading && (
            <Box display="flex" alignItems="center" gap={2}>
              <CircularProgress size={24} />
              <Typography>{statusMessage}</Typography>
            </Box>
          )} */}

          {/* Success State */}
          {status === "completed" && !loading && (
            <Box textAlign="center" py={2}>
              <Box
                sx={{
                  width: 60,
                  height: 60,
                  borderRadius: "50%",
                  bgcolor: "success.light",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mx: "auto",
                  mb: 2,
                }}
              >
                <Typography fontSize={30}>✓</Typography>
              </Box>
              <Typography variant="h6" gutterBottom>
                Your video is ready!
              </Typography>
              <Typography variant="body2" color="rgba(255, 255, 255, 0.80)">
                Click Download to save your video
              </Typography>
            </Box>
          )}

          {/* Error State */}
          {status === "failed" && (
            <Box textAlign="center" py={2}>
              <Box
                sx={{
                  width: 60,
                  height: 60,
                  borderRadius: "50%",
                  bgcolor: "error.light",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mx: "auto",
                  mb: 2,
                }}
              >
                <Typography fontSize={30} color="error">
                  ✕
                </Typography>
              </Box>
              <Typography variant="h6" gutterBottom color="error">
                Generation Failed
              </Typography>
              <Typography variant="body2" color="error">
                {errorMsg || "An error occurred during video generation"}
              </Typography>
              <Typography
                variant="caption"
                display="block"
                mt={2}
                color="#ffffff"
              >
                Please try again or contact support if the issue persists
              </Typography>
            </Box>
          )}
        </Box>
      </DialogContent>
      <DialogActions sx={{display:"flex",padding:"16px 20px", maxHeight:"72px"}}>
        {status === "processing" && (
          <Button onClick={onClose} disabled>
            Processing...
          </Button>
        )}
        {status === "pending" && !errorMsg && (
          <Button onClick={onClose} 
          sx={{
                    width: "103px",
                    height: "40px",
                    textTransform: "none",
                    fontFamily: "Inter",
                    fontSize: "16px",
                    fontWeight: 600,
                    textAlign: "center",
                    bgcolor: "#FFFFFF",
                    color: "#17182C",
                    '&:hover': {
                        backgroundColor: '#CDCFDF'
                      },
              }}
          >Cancel</Button>
        )}
        {status === "failed" && (
          <Button onClick={onClose} color="error" 
           sx={{
                    width: "103px",
                    height: "40px",
                    textTransform: "none",
                    fontFamily: "Inter",
                    fontSize: "16px",
                    fontWeight: 600,
                    textAlign: "center",
                    bgcolor: "#DD2025",
                    color: "#FFFFFF",
                    '&:hover': {
                        backgroundColor: '#E6E0E91F'
                      },
                  }}
          >
            Close
          </Button>
        )}
        {status === "completed" && (
          <>
            <Button onClick={onClose}
             sx={{
                    width: "103px",
                    height: "40px",
                    textTransform: "none",
                    fontFamily: "Inter",
                    fontSize: "16px",
                    fontWeight: 600,
                    textAlign: "center",
                    bgcolor: "#FFFFFF",
                    color: "#17182C",
                    '&:hover': {
                        backgroundColor: '#CDCFDF'
                      },
              }}
            >Close</Button>
            <Button 
              variant="contained"
              color="primary"
            //   onClick={handlePrimaryClick}
               sx={{
                backgroundColor:theme === 'dark'? button_bg_color_for_New_Project :'',
                         '&:hover': {
                           backgroundColor:'#FFD9AA',
                         },
                         color:'#17182C',
                         fontSize:'16px',
                         fontWeight:600,
                         textTransform:'none',
                         fontFamily: 'Inter, sans-serif',}}
            >
              View Video
              {/* Original text: Download Video */}
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  )
}

export default VideoCreationDialogForVeo